/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import _ from 'lodash';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import { connect } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { INIT_CONFIG } from 'lib/tiny-mce';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../../cms/action';
import * as c from '../../cms/constant';
import { getType, getManagePermission } from '../helper';

const CreatePermit = ({
  history,
  getList,
  update,
  item,
  setFormData,
  formData,
  htmlToDraft,
  convertToRaw,
  draftToHtml,
  updating,
  match,
}) => {
  const [content, setContent] = useState('');
  const [placeholderImg, setPlaceholderImg] = useState('');
  const [checkedItems, setCheckedItems] = useState([]);
  const editorRef = useRef(null);
  const permit = _.get(match, 'params.permit', '');
  const permissions = getJson('permissions');
  const canManage = Acl(permissions, [getManagePermission(permit)]);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    let newCheckedItems;

    if (checked) {
      newCheckedItems = [...checkedItems, name];
    } else {
      newCheckedItems = checkedItems.filter((item) => item !== name);
    }

    setCheckedItems(newCheckedItems);

    if (editorRef.current) {
      const editor = editorRef.current;
      if (checked) {
        editor.insertContent(`[${name}]`);
      } else {
        const currentContent = editor.getContent();
        const updatedContent = currentContent.replace(`[${name}]`, '');
        editor.setContent(updatedContent);
      }
    }
  };

  useEffect(() => {
    if (permit) {
      getList({ type: getType(permit) });
    }
  }, [permit]);

  useEffect(() => {
    if (item) {
      const retrievedData = JSON.parse(_.get(item, 'attributes.body') || '{}');
      const items =
        (JSON.parse(_.get(item, 'attributes.body') || '{}')[0] || {}).items ??
        [];

      setCheckedItems(items);

      setFormData({
        id: _.get(item, 'id'),
        PERMITS: _.get(retrievedData, 'PERMITS'),
      });
    }
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    let data = _.get(item, '0.attributes.body');

    if (typeof data === 'string') {
      data = JSON.parse(data || '[]');
    }

    data = Array.isArray(data) ? data : [];

    const payload = {
      selected: false,
      body: content,
      items: checkedItems,
      placeholderImg: placeholderImg,
    };

    data.push(payload);

    if (_.get(item, '0.id')) {
      return update(
        _.get(item, '0.id'),
        {
          // type: getType(permit),
          body: JSON.stringify(data),
        },
        (data) => {
          history.push(`/general-settings/templates/${permit}`);
        }
      );
    }
  };

  if (!canManage) {
    return <Redirect to={`/general-settings/templates/${permit}`} />;
  }

  return (
    <form
      onSubmit={handleOnSubmit}
      className="d-flex overflow-hidden"
      style={{ gap: '10px' }}
    >
      <div
        className="border rounded bg-white p-2 w-27"
        style={{ overflow: 'auto' }}
      >
        <div
          className="d-flex align-items-center justify-content-between gap-2"
          style={{ gap: '10px' }}
        >
          <div className="alert alert-primary" role="alert">
            <div className="d-flex align-items-center" style={{ gap: '20px' }}>
              <div className="fa fa-info" />
              Check the following items below to be included in the customized
              template.
            </div>
          </div>
        </div>
        <table className="table table-bordered table-sm mb-0">
          <tbody>
            {c.PERMIT_APPLICATIONS.sort((a, b) => a.localeCompare(b)).map(
              (key) => (
                <tr key={key}>
                  <td className="bg-light" colSpan={2}>
                    <label style={{ marginBottom: '0px' }}>
                      <input
                        type="checkbox"
                        name={key}
                        checked={checkedItems.includes(key)}
                        onChange={handleCheckboxChange}
                      />
                      <span style={{ fontSize: '14px', marginLeft: '4px' }}>
                        {_.startCase(_.toLower(key.replace(/_/g, ' ')))}
                      </span>
                    </label>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>

      <div className="w-73 d-flex flex-column" style={{ minHeight: 0 }}>
        <div className="alert alert-primary" role="alert">
          <div className="d-flex align-items-center" style={{ gap: '20px' }}>
            <div className="fa fa-info" />
            FOR THE SELECTED/ACTIVE TEMPLATE: To use the default pre-defined
            template, click the Customize Template button then update the
            "Status" of the customized template and Save.
          </div>
        </div>

        <Editor
          className="flex-grow-1"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={
            (JSON.parse(_.get(item, 'attributes.body') || '{}')[0] || {})
              .body ?? ''
          }
          apiKey={process.env.REACT_APP_TINY_MCE_KEY}
          init={INIT_CONFIG}
          onEditorChange={(newValue) => {
            if (newValue.includes('.placeImage')) {
              const extractBackgroundImageUrl = (html) => {
                // Extract style contents
                const styleContent =
                  html.match(/<style[^>]*>([\s\S]*?)<\/style>/gi) || [];
                // Find URL in .placeImage class
                const urlMatch = styleContent
                  .join(' ')
                  .match(
                    /\.placeImage\s*\{\s*background-image:\s*url\(['"]([^'"]+)['"]\)/i
                  );
                return urlMatch ? urlMatch[1] : null;
              };

              const backgroundImageUrl = extractBackgroundImageUrl(newValue);
              setPlaceholderImg(backgroundImageUrl);
            }
            setContent(newValue);
          }}
        />

        <div className="d-flex justify-content-center">
          <button
            onClick={() =>
              history.push(`/general-settings/templates/${permit}`)
            }
            type="button"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Back</span>
          </button>
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Create`}
            </span>
          </button>
        </div>
      </div>
    </form>
  );
};

CreatePermit.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: _.get(api, `${c.GET_SETTINGS}.list`) || [] || {},
  updating: api.loading.indexOf(c.UPDATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(CreatePermit);
